import { ContactsPage, PageHead } from '@/components'

const meta = {
    title: 'Контакты | "Центр финансовых консультаций"',
    description:
        'Контакты "Центр финансовых консультаций". Офисы по всей территории Беларуси. Приходите к нам! Мы рядом! Выгодное и честное кредитование',
}

const Contacts = ({ cities }) => {
    return (
        <>
            <PageHead meta={meta}/>
            <ContactsPage cities={cities} />
        </>
    )
}

Contacts.options = {
    header: 'contacts',
    footer: 'none',
}

Contacts.getInitialProps = async ({ api, query }) => {
    const cities = await api.cities({ search: query.search })

    return { cities: cities.data }
}

export default Contacts
